import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const YesNoText = styled.span<{ isYes: boolean }>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ isYes }) => (isYes ? "#22c55e" : "#000")};
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const YesNo = ({ cell: { getValue } }: Props) => {
  const value = getValue().value
  const stringValue = String(value || "").toLowerCase()
  const isYes = stringValue === "yes"
  const displayValue = isYes ? "Yes" : "No"

  return <YesNoText isYes={isYes}>{displayValue}</YesNoText>
}
